import React from 'react';
import {Controlled} from './Controlled.story';
import {DisabledReadOnly} from './DisabledReadOnly.story';
import {Invalid} from './Invalid.story';
import {Primary} from './Primary.story';
import {Rows} from './Rows.story';
import {Size} from './Size.story';
import {Uncontrolled} from './Uncontrolled.story';
import {Width} from './Width.story';

const basic = {
  rendered: <Primary />,
  source: `<TextArea
  label="Biography"
  placeholder="Acme Inc was founded in…"
  defaultValue={EXAMPLE_TEXT}
/>`,
};

const resizeable = {
  rendered: <div>Currently unsupported</div>,
  source: `// currently unsupported`,
};

const rows = {
  rendered: <Rows />,
  source: `<div>
  <View css={{paddingY: 'medium'}}>
    <TextArea
      label="Biography (3 rows, default)"
      defaultValue={EXAMPLE_TEXT}
    />
  </View>
  <View css={{paddingY: 'medium'}}>
    <TextArea
      label="Biography (6 rows)"
      rows={6}
      defaultValue={EXAMPLE_TEXT}
    />
  </View>
</div>`,
};

const size = {
  rendered: <Size />,
  source: `View
  uses={[
    css({
      '& > *': {
        padding: css.value('8px 0'),
      },
    }),
  ]}
>
  <TextArea
    label="Biography (large)"
    size="large"
    defaultValue={EXAMPLE_TEXT}
  />
  <TextArea
    label="Biography (medium, default)"
    size="medium"
    defaultValue={EXAMPLE_TEXT}
  />
  <TextArea
    label="Biography (small)"
    size="small"
    defaultValue={EXAMPLE_TEXT}
  />
</View>
);`,
};

const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<TextArea
  onChange={(e) => {
    console.log(e);
  }}
  label="About your business"
  placeholder="Our business is…"
/>`,
};

const width = {
  rendered: <Width />,
  source: `<TextArea
  label="App feedback"
  defaultValue={EXAMPLE_TEXT}
  css={{width: css.value('350px')}}
/>`,
};

const invalid = {
  rendered: <Invalid />,
  source: `<TextArea label="Favorite word" defaultValue={EXAMPLE_TEXT} invalid />`,
};

const disabledReadOnly = {
  rendered: <DisabledReadOnly />,
  source: ` <div>
  <View css={{paddingY: 'medium'}}>
    <TextArea label="Disabled" defaultValue={EXAMPLE_TEXT} disabled />
  </View>
  <View css={{paddingY: 'medium'}}>
    <TextArea label="Readonly" defaultValue={EXAMPLE_TEXT} readOnly />
  </View>
</div>`,
};

const controlled = {
  rendered: <Controlled />,
  source: `const [textValue, setTextValue] = React.useState<string>();
return (
  <TextArea
    value={textValue}
    onChange={(e) => {
      setTextValue(e.target.value);
      console.log(e);
    }}
    label="About your business"
    placeholder="Our business is…"
  />
);`,
};

export const TextareaExamples = {
  basic,
  controlled,
  uncontrolled,
  disabledReadOnly,
  invalid,
  width,
  size,
  rows,
  resizeable,
};
